import { cn, getCurrencyLabel } from "@/lib/util/utils";
import { Button } from "@/modules/common/components/button";
import { useCurrencyStore } from "@/store/index";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

export const CurrencySelector = () => {
  const { currencyCode, setCurrency } = useCurrencyStore();
  const [isCurrencyOpen, setIsCurrencyOpen] = useState(false);

  return (
    <div className="relative">
      <Button
        variant="ghost"
        onClick={() => setIsCurrencyOpen(!isCurrencyOpen)}
        className="font-inter flex items-center gap-1 rounded-lg text-sm font-medium transition-colors hover:bg-white/50"
      >
        <span>{getCurrencyLabel(currencyCode)}</span>
        <ChevronDown className="h-4 w-4" />
      </Button>
      {isCurrencyOpen && (
        <div className="absolute top-12 right-0 z-50 w-32 rounded-lg bg-white p-2 shadow-lg">
          {(["USD", "EUR", "CAD"] as const).map((curr) => (
            <button
              key={curr}
              onClick={() => {
                setCurrency(curr);
                setIsCurrencyOpen(false);
              }}
              className={cn(
                "font-inter w-full rounded px-3 py-2 text-left text-sm transition-colors hover:bg-gray-100",
                currencyCode === curr &&
                  "bg-green-main/10 text-green-main font-semibold"
              )}
            >
              {getCurrencyLabel(curr)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
